import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../../../../store/selectors/app.selector";
import { NumericFormat } from "react-number-format";
import AccountService from "../../../../services/accounts.service";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphabetsWithSpace,
  allowOnlyNumbers,
  amountFormat,
} from "../../../../services/common.service";
import moment from "moment";
import CommonOtp from "../../../../components/otp";
import handIcon from "../../../../assests/images/hand_icon.png";
import {
  getErrorMessageSelector,
  getErrorModalVisibleMessageSelector,
} from "../../../../store/selectors/error.selector";
import { setErrorModalClose } from "../../../../store/actions/error.action";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import AccountDisplay from "../../../../components/account-display";
import { ReactComponent as CheckedIcon } from "../../../../assests/images/checked.svg";
import unCheckedIcon from "../../../../assests/icons/uncheck.png";
import { ReactComponent as TickIcon } from "../../../../assests/images/tickIcon.svg";
import AccountCard from "../../../../components/account-card";
import { CONFIG } from "../../../../environment";

export default function OpenDeposit() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [formType, setFormType] = useState("DEPOSIT_FORM");
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const accountList = useSelector(accountListSelector);
  const [branchList, setBranchList] = useState([]);
  const [productList, setProductList] = useState({
    guardianRelationShipCodes: [],
    stateCodesList: [],
    nomineeRelationShipCodes: [],
    fixedDepositTypes: [],
  });
  const [payoutList, setPayoutList] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [reqData, setReqData] = useState({});
  const [depositTypes, setDepositTypes] = useState([]);
  const [years] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  const [months, setMonths] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
  const [days] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]);
  const [resident, setResident] = useState("");
  const [type, setType] = useState("FD");
  const [nomineeType, setNomineeType] = useState("EXISTING");
  const [nomineeList, setNomineeList] = useState([]);
  const [nomineeDetails, setNomineeDetails] = useState({});
  const [respDetails, setRespDetails] = useState({});
  const [nomineeMinorFlg, setNomineeMinorFlg] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [depositDetails, setDepositDetails] = useState({});
  const [selectedDepositType, setSelectedDepositType] =
    useState("FIXED_DEPOSIT");
  const [visible, setVisible] = useState(false);
  const [durationErrorVisible, setDurationErrorVisible] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const errorModalVisible = useSelector(getErrorModalVisibleMessageSelector);
  const errorMessage = useSelector(getErrorMessageSelector);
  const dispatch = useDispatch();
  const [min7Days, setMin7Days] = useState(false);
  const [duration10Years, setDuration10Years] = useState(false);
  const { t } = useTranslation();
  const [isNominee, setIsNominee] = useState(true);
  const selectedAccount = useSelector(selectedAccountSelector);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    if (errorModalVisible && errorMessage === null) {
      dispatch(setErrorModalClose(false));
      navigate("/accounts", { state: "FD" });
    }
  }, [errorModalVisible, errorMessage]);

  useEffect(() => {
    getProducts();
    //getCityDetails();
  }, []);

  useEffect(() => {
    if (accountList.length > 0) {
      form.setFieldsValue({
        branch: selectedAccount.branchName,
        depositType: "FD",
      });
    }
  }, [accountList]);

  const getCityDetails = useCallback(async () => {
    try {
      const response = await AccountService.getCityDetails();
      if (response.status === 200) {
        setCityList(response.data["cityNames"]);
      }
    } catch (error) {}
  }, []);

  const getProducts = useCallback(async () => {
    try {
      const response = await AccountService.getProducts();
      if (response.status === 200) {
        const { acctNo } = accountList[0];
        setProductList(response.data);
        setBranchList(response.data["brancheDetails"]);
        setPayoutList(response.data["interestPayout"].split("~"));
        const fixedDepositTypes = response.data["fixedDepositTypes"].filter(
          (ele) => ele.depositType !== "Recurring Deposit"
        );
        fixedDepositTypes.forEach((element, idx) => {
          element.active = idx === 0 ? true : false;
          element.type = element.depositName.replaceAll(" ", "_").toUpperCase();
          if (element.depositType === "Fixed Deposit") {
            element.visible = true;
          } else {
            element.visible =
              response["data"]["accountsWithResident"][acctNo] === "NRE"
                ? false
                : true;
          }
        });
        setResident(response["data"]["accountsWithResident"][acctNo]);
        setSelectedDepositType("FIXED_DEPOSIT");
        setDepositTypes(fixedDepositTypes);
        setDepositDetails(fixedDepositTypes[0]);
      }
    } catch (error) {}
  }, [accountList]);

  const getNomineeDetails = useCallback(async (values) => {
    try {
      const req = {
        accountNo: values?.accountNo,
      };
      const response = await AccountService.getNomineeDetails(req);
      if (response.status === 200) {
        setNomineeList(response.data);
        const data = response.data[0] || {};
        handleSetFormValues(data, "EXISTING");
        setLoader(false);
        if (values?.isNominee === true) {
          setFormType("NOMINEE_FORM");
        } else {
          setStage(2);
        }
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  const handleNomineeChange = useCallback(
    (value) => {
      try {
        const data = nomineeList.find((ele) => ele.nomineeName === value);
        handleSetFormValues(data, "EXISTING");
      } catch (error) {}
    },
    [nomineeList]
  );

  const handleNomineeType = useCallback(
    (type) => {
      try {
        setNomineeType(type);
        setNomineeMinorFlg(false);
        const data = type === "EXISTING" ? nomineeList[0] : {};
        handleSetFormValues(data, type);
      } catch (error) {}
    },
    [nomineeList]
  );

  const handleSetFormValues = useCallback(
    (data = {}, nomineeType = "EXISTING") => {
      try {
        setNomineeDetails(data);
        form.setFieldsValue({
          nomineeName: data?.nomineeName,
          nomineeRelation: data?.nomineeRelation,
          nomineeAddress: data?.nomineeAddress,
          nomineeDateOfBirth: undefined,
          nomineeCity: data?.nomineeCity?.value,
          nomineeState: data?.nomineeState?.value,
          nomineePostalCode: data?.nomineePINCode,
          nomineeCountry: undefined,
          nomineeAddress1: data?.nomineeAddress1,
          nomineeAddress2: data?.nomineeAddress2,
          nomineeType: nomineeType,
        });
      } catch (error) {}
    },
    []
  );

  const openFdOrRdVerify = useCallback(async () => {
    try {
      const depositAmount =
        typeof formValues.amount === "number"
          ? formValues.amount
          : parseFloat(formValues.amount.replaceAll(/,/g, ""));

      const depositTypeDetails =
        type === "FD"
          ? depositTypes.find((ele) => ele.active === true)
          : productList["fixedDepositTypes"]?.find(
              (ele) => ele.depositName === "Recurring Deposit"
            );

      const reqParams = {
        branch: formValues.branch,
        interestPayout: formValues?.interestPayout || "",
        debitAcctNo: formValues?.accountNo,
        // accountNo: formValues?.accountNo,
        amount: depositAmount,
        years: formValues?.years || 0,
        months: formValues?.months || 0,
        days: formValues?.days || 0,
        depositType: depositTypeDetails?.depositType,
        depositName: depositTypeDetails?.depositName,
        productId: depositTypeDetails?.productId,
        interestRate: "",
        maturityAmount: "",
        nomineeMinorFlg: nomineeMinorFlg ? "Y" : "N",
        addNominee: formValues?.isNominee,
        remarks: "",
        guardianName: formValues?.guardianName || "",
        guardianAddress: formValues?.guardianAddress || "",
        guardianAddress1: formValues?.guardianAddress1 || "",
        guardianAddress2: formValues?.guardianAddress2 || "",
        guardianRelation: formValues?.guardianRelation || "",
        guardianGender: formValues?.guardianGender || "",
        guardianCity: formValues?.guardianCity || "",
        guardianState: formValues?.guardianState || "",
        guardianPostalCode: formValues?.guardianPostalCode || "",
        guardianCountry: formValues?.guardianCountry || "",
        nomineeName: formValues?.nomineeName || "",
        nomineeRelation: formValues?.nomineeRelation || "",
        nomineeAddress: formValues?.nomineeAddress || "",
        nomineeDateOfBirth: formValues?.nomineeDateOfBirth || "",
        nomineeCity: formValues?.nomineeCity || "",
        nomineeState: formValues?.nomineeState || "",
        nomineePostalCode: formValues?.nomineePostalCode || "",
        nomineeCountry: formValues?.nomineeCountry || "",
        nomineeAddress1: formValues?.nomineeAddress1 || "",
        nomineeAddress2: formValues?.nomineeAddress2 || "",
        resident: resident,
      };
      setReqData(reqParams);
      setLoader(true);
      const response = await AccountService.openFdOrRdVerify(reqParams);
      if (response.status === 200) {
        setLoader(false);
        setStage(3);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }, [
    formValues,
    nomineeDetails,
    depositTypes,
    type,
    productList,
    nomineeMinorFlg,
    resident,
  ]);

  const openFdOrRdConfirm = useCallback(async (values) => {
    try {
      setLoader(true);
      const response = await AccountService.openFdOrRdConfirm(values);
      if (response.status === 200) {
        setLoader(false);
        setRespDetails(response.data["data"]);
        setStage(4);
      }
    } catch (error) {
      setLoader(false);
      setOtp("");
    }
  }, []);

  const handleResendOtp = useCallback(async (values) => {
    try {
      setLoader(true);
      const response = await AccountService.openFdOrRdVerify(values);
      if (response.status === 200) {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  const onVerify = useCallback(
    async (values) => {
      try {
        const accountNo = selectedAccount?.accountNo;
        setFormValues((currentData) => {
          return { ...currentData, ...values, accountNo, isNominee };
        });

        if (formType === "DEPOSIT_FORM") {
          const depositAmount =
            typeof values.amount === "number"
              ? values.amount
              : parseFloat(values.amount.replaceAll(/,/g, ""));

          const { fdMiniAmount, rdMiniAmount } = productList;

          if (
            values.depositType === "FD" &&
            depositAmount < parseFloat(fdMiniAmount)
          ) {
            setVisible(true);
            return;
          }

          if (
            values.depositType === "RD" &&
            depositAmount < parseFloat(rdMiniAmount)
          ) {
            setVisible(true);
            return;
          }

          if (
            parseInt(values?.days || 0) === 0 &&
            parseInt(values?.months || 0) === 0 &&
            parseInt(values?.years || 0) === 0
          ) {
            setDurationErrorVisible(true);
            return;
          }

          if (
            resident !== "NRE" &&
            parseInt(values?.days || 0) < 7 &&
            parseInt(values?.months || 0) === 0 &&
            parseInt(values?.years || 0) === 0
          ) {
            setDurationErrorVisible(true);
            setMin7Days(true);
            return;
          }
          let duration = 0;
          if (values?.years) {
            duration = parseInt(values?.years || 0) * 12;
          }
          if (values?.months) {
            duration = duration + parseInt(values?.months || 0);
          }
          if (values?.interestPayout !== "Pay on Maturity" && duration < 12) {
            setDurationErrorVisible(true);
            return;
          }

          const depositTypeDetails =
            values.depositType === "FD"
              ? depositTypes.find((ele) => ele.active === true)
              : productList["fixedDepositTypes"]?.find(
                  (ele) => ele.depositName === "Recurring Deposit"
                );
          setLoader(true);
          const reqparams = {
            ...values,
            accountNo: accountNo,
            isNominee: isNominee,
          };
          getNomineeDetails(reqparams);
        } else {
          setStage(2);
        }
      } catch (error) {
        console.log(error);
        setLoader(false);
      }
    },
    [formType, depositTypes, productList, resident, selectedAccount, isNominee]
  );

  const handleDepositType = useCallback(
    (option) => {
      try {
        setDuration10Years(false);
        setSelectedDepositType(option?.type);
        setDepositDetails(option);
        const depositTypesCopy = [...depositTypes];
        depositTypesCopy.forEach((element) => {
          if (element.type === option.type) {
            element.active = true;
          } else {
            element.active = false;
          }
        });
        setDepositTypes(depositTypesCopy);
        form.setFieldsValue({
          interestPayout: undefined,
          days: undefined,
          months: undefined,
          years: undefined,
        });
      } catch (error) {}
    },
    [depositTypes]
  );

  const handleInterestPayoutChange = useCallback(
    (value) => {
      try {
        const depositTypeDetails = depositTypes.find(
          (ele) => ele.active === true
        );
        if (depositTypeDetails?.type !== "FIXED_DEPOSIT") {
          const durationDetails = depositTypeDetails?.duration?.find(
            (ele) => ele.interestPayout === value && ele.resident === resident
          );

          const fixedDurationValue = durationDetails?.depositDuration?.slice(
            0,
            durationDetails?.depositDuration?.length - 1
          );

          form.setFieldsValue({
            interestPayout: value,
            days:
              durationDetails?.depositDuration?.slice(-1) === "D"
                ? fixedDurationValue
                : 0,
            months:
              durationDetails?.depositDuration?.slice(-1) === "M"
                ? fixedDurationValue
                : 0,
            years:
              durationDetails?.depositDuration?.slice(-1) === "Y"
                ? fixedDurationValue
                : 0,
          });
        } else {
          form.setFieldsValue({
            days: undefined,
            months: undefined,
            years: undefined,
          });
        }
      } catch (error) {}
    },
    [depositTypes, resident]
  );

  const handleOpenType = useCallback(
    (e) => {
      setType(e.target.value);
      setErrorList([]);
      form.setFieldsValue({
        interestPayout: undefined,
        days: undefined,
        months: undefined,
        years: undefined,
      });
      setDuration10Years(false);
      if (e.target.value === "RD") {
        let months = [];
        for (let index = 12; index <= 120; index++) {
          months.push(index);
        }
        setMonths(months);
        setSelectedDepositType("");
        setDepositDetails(
          productList?.fixedDepositTypes?.find(
            (ele) => ele.depositType === "Recurring Deposit"
          )
        );
      } else {
        setMonths([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
        const depositTypesCopy = [...depositTypes];
        depositTypesCopy.forEach((element) => {
          if (element.type === "FIXED_DEPOSIT") {
            element.active = true;
          } else {
            element.active = false;
          }
        });
        setDepositTypes(depositTypesCopy);
        setSelectedDepositType("FIXED_DEPOSIT");
        setDepositDetails(depositTypesCopy[0]);
      }
    },
    [depositTypes, productList]
  );

  const onFinishFailed = useCallback(({ errorFields = [] }) => {
    try {
      let errors = [];
      errorFields.forEach((ele) => {
        errors = [...errors, ...ele.name];
      });
      console.log(errors);
      setErrorList(errors);
    } catch (error) {}
  }, []);

  const onFieldsChange = useCallback(
    (errorData = []) => {
      try {
        const errorListCopy = [...errorList];
        errorData.forEach((ele) => {
          const name = ele.name[0];
          if (name === "days" || name === "months" || name === "years") {
            if (ele.value !== undefined) {
              const index = errorListCopy.indexOf(name);
              if (index > -1) {
                errorListCopy.splice(index, 1);
              }
            }
          }
        });
        setErrorList(errorListCopy);
      } catch (error) {}
    },
    [errorList]
  );

  const durationChange = useCallback((value, name) => {
    try {
      const { days, months, years } = form.getFieldsValue();

      if (years === 10) {
        form.setFieldsValue({
          days: 0,
          months: 0,
          years: years || 0,
        });
        setDuration10Years(true);
      } else {
        form.setFieldsValue({
          days: days || 0,
          months: months || 0,
          years: years || 0,
        });
        setDuration10Years(false);
      }
    } catch (error) {}
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) => openFdOrRdConfirm({ ...reqData, ...values })}
            handleResendOtp={() => handleResendOtp(reqData)}
            cancelTransaction={() => {
              setStage(1);
              setFormType("DEPOSIT_FORM");
              setNomineeMinorFlg(false);
              setNomineeType("EXISTING");
            }}
          />
        );

      case 4:
        return renderSuccess();

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <Form
          layout="vertical"
          name="depositForm"
          form={form}
          onFinish={onVerify}
          onFinishFailed={onFinishFailed}
          onFieldsChange={onFieldsChange}
        >
          {formType === "DEPOSIT_FORM" && (
            <>
              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  {" "}
                  <Form.Item
                    label={t("pages.my_accounts.deposits.open_as", {
                      defaultValue: "Open as",
                    })}
                    name={"depositType"}
                  >
                    <Radio.Group
                      onChange={(e) => handleOpenType(e)}
                      value={type}
                    >
                      <Radio value={"FD"}>
                        {t("pages.accounts.deposits.fixed_deposit", {
                          defaultValue: "Fixed Deposit",
                        })}
                      </Radio>
                      <Radio value={"RD"}>
                        {t("pages.accounts.deposits.recurring_deposit", {
                          defaultValue: "Recurring Deposit",
                        })}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>

                <div className="row">
                  {" "}
                  <div className="col-6">
                    {" "}
                    <AccountDisplay type="list" />
                  </div>
                </div>

                <div className="col-6">
                  <Form.Item
                    label={t("common.amount", { defaultValue: "Amount" })}
                    name={"amount"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.amount_required", {
                          defaultValue: "Amount is required",
                        }),
                      },
                      {
                        validator: (_, value) => {
                          if (parseFloat(value) <= 0) {
                            return Promise.reject(
                              t("errorMesssages.amount_validation", {
                                defaultValue: "Amount should be greater than 0",
                              })
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <NumericFormat
                      type="tel"
                      placeholder={t("common.amount", {
                        defaultValue: "Amount",
                      })}
                      maxLength={12}
                      allowNegative={false}
                      customInput={Input}
                      thousandSeparator={true}
                      fixedDecimalScale={false}
                      onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                      size="large"
                    />
                  </Form.Item>
                </div>

                <div className="col-6">
                  <Form.Item
                    label={"Open " + type + " In"}
                    name="branch"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.accounts.accounts_common.amount_req_txt",
                          { defaultValue: "Amount is required" }
                        ),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder={t("pages.accounts.deposits.Open_fd_in", {
                        defaultValue: "Open FD in",
                      })}
                      size="large"
                    >
                      {branchList.map((option, idx) => (
                        <Select.Option key={idx} value={option.label}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                {type === "FD" && (
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Item
                      label={t("pages.accounts.deposits.interest_payout", {
                        defaultValue: "Interest payout",
                      })}
                      name="interestPayout"
                      rules={[
                        {
                          required: true,
                          message: t(
                            "pages.accounts.deposits.interest_payout_req_txt",
                            { defaultValue: "Interest payout is required" }
                          ),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder={t(
                          "pages.accounts.deposits.interest_payout",
                          { defaultValue: "Interest payout" }
                        )}
                        onChange={handleInterestPayoutChange}
                        size="large"
                      >
                        {payoutList.map((option, idx) => (
                          <Select.Option key={idx} value={option}>
                            {option}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <p className="label-style">
                    {" "}
                    {t("pages.accounts.deposits.duration", {
                      defaultValue: "Duration",
                    })}
                  </p>
                  <div className="duration-fields">
                    {type === "FD" && (
                      <div
                        className="d-flex align-items-center"
                        style={{ marginRight: 12 }}
                      >
                        <Form.Item
                          label=""
                          name="years"
                          rules={[{ required: true, message: "" }]}
                        >
                          <Select
                            disabled={
                              selectedDepositType === "SPECIAL_SCHEME_FD" ||
                              selectedDepositType === "TAX_BENEFIT"
                            }
                            style={{ width: 120 }}
                            placeholder={t("pages.accounts.deposits.years", {
                              defaultValue: "Years",
                            })}
                            onChange={(value) => durationChange(value, "years")}
                            size="large"
                          >
                            {years.map((option, idx) => (
                              <Select.Option value={option} key={idx}>
                                {option}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <span style={{ paddingLeft: 10, marginTop: "-20px" }}>
                          {t("pages.accounts.deposits.years", {
                            defaultValue: "Years",
                          })}
                        </span>
                      </div>
                    )}

                    <div
                      className="d-flex align-items-center"
                      style={{ marginRight: 12 }}
                    >
                      <Form.Item
                        label=""
                        name="months"
                        rules={[{ required: true, message: "" }]}
                      >
                        <Select
                          disabled={
                            selectedDepositType === "SPECIAL_SCHEME_FD" ||
                            selectedDepositType === "TAX_BENEFIT" ||
                            duration10Years
                          }
                          style={{ width: 140 }}
                          placeholder={t("pages.accounts.deposits.months", {
                            defaultValue: "Months",
                          })}
                          onChange={(value) => durationChange(value, "months")}
                          size="large"
                        >
                          {months.map((option, idx) => (
                            <Select.Option value={option} key={idx}>
                              {option}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <span style={{ paddingLeft: 10, marginTop: "-20px" }}>
                        {t("pages.accounts.deposits.months", {
                          defaultValue: "Months",
                        })}
                      </span>
                    </div>
                    {type === "FD" && (
                      <div className="d-flex align-items-center">
                        <Form.Item
                          label=""
                          name="days"
                          rules={[{ required: true, message: "" }]}
                        >
                          <Select
                            disabled={
                              selectedDepositType === "SPECIAL_SCHEME_FD" ||
                              selectedDepositType === "TAX_BENEFIT" ||
                              duration10Years
                            }
                            style={{ width: 120 }}
                            placeholder={t("pages.accounts.deposits.days", {
                              defaultValue: "Days",
                            })}
                            onChange={(value) => durationChange(value, "days")}
                            size="large"
                          >
                            {days.map((option, idx) => (
                              <Select.Option value={option} key={idx}>
                                {option}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <span style={{ paddingLeft: 10, marginTop: "-20px" }}>
                          {t("pages.accounts.deposits.days", {
                            defaultValue: "Days",
                          })}
                        </span>
                      </div>
                    )}
                  </div>
                  {(errorList.indexOf("days") > -1 ||
                    errorList.indexOf("months") > -1 ||
                    errorList.indexOf("years") > -1) && (
                    <div style={{ marginTop: "-22px", color: "red" }}>
                      {t("pages.accounts.deposits.duration_is_required", {
                        defaultValue: "Duration is required",
                      })}
                    </div>
                  )}
                </div>
                {type === "FD" && (
                  <div className="col-12">
                    <p className="label-style">
                      {t("pages.accounts.deposits.deposit_type", {
                        defaultValue: "Deposit Type",
                      })}
                    </p>
                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                      <div className="row">
                        {depositTypes.map((option, idx) => (
                          <>
                            {option.visible && (
                              <div
                                onClick={() => handleDepositType(option)}
                                key={idx}
                                className="col-12 col-sm-12 col-md-6 col-lg-4"
                              >
                                <div
                                  className={
                                    option.active
                                      ? "deposit-type-card deposit-type-active"
                                      : "deposit-type-card"
                                  }
                                >
                                  <span>{option.depositName}</span>
                                  <div
                                    onClick={() =>
                                      window.open(option.moreInfoLink, "_blank")
                                    }
                                    className="know-more"
                                  >
                                    {t("pages.accounts.deposits.know_more", {
                                      defaultValue: "Know more",
                                    })}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex align-items-center justify-content-between mt-5">
                  <div
                    onClick={() => {
                      setIsNominee(!isNominee);
                    }}
                  >
                    <span style={{ marginRight: "5px ", cursor: "pointer" }}>
                      {isNominee ? (
                        <CheckedIcon
                          className="checked"
                          alt="checked"
                          height={20}
                          width={20}
                        />
                      ) : (
                        <img
                          src={unCheckedIcon}
                          alt="unchecked"
                          height={20}
                          width={20}
                          className="unchecked"
                        />
                      )}
                    </span>
                    {t("pages.my_accounts.deposits.nominee_required", {
                      defaultValue: "Nominee Required",
                    })}
                  </div>
                  <div>
                    <Button
                      onClick={() => navigate("/accounts", { state: "FD" })}
                      type="default"
                      className="secondary-btn"
                      style={{ marginRight: 20 }}
                      size="large"
                    >
                      {t("buttons.cancel_btn", { defaultValue: "Cancel" })}
                    </Button>
                    <Button
                      loading={loader}
                      type="primary"
                      htmlType="submit"
                      size="large"
                    >
                      {t("buttons.next_btn", { defaultValue: "Next" })}
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}

          {formType === "NOMINEE_FORM" && (
            <>
              <Form.Item label="" name={"nomineeType"}>
                <Radio.Group
                  onChange={(e) => handleNomineeType(e.target.value)}
                  value={nomineeType}
                >
                  <Radio value={"EXISTING"}>
                    {t("pages.accounts.deposits.nominee_for", {
                      defaultValue: "Nominee for a/c",
                    })}
                  </Radio>
                  <Radio value={"NEW"}>
                    {t("pages.accounts.deposits.add_new_nominee", {
                      defaultValue: "Add a new nominee",
                    })}
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <div className="row">
                {nomineeType === "EXISTING" && (
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Item
                      label={t("pages.accounts.deposits.existing_nominee", {
                        defaultValue: "Existing Nominee",
                      })}
                      name={"nomineeName"}
                      rules={[
                        {
                          required: true,
                          message: t(
                            "pages.accounts.deposits.existing_nominee_req_txt",
                            { defaultValue: "Existing Nominee is required" }
                          ),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder={t(
                          "pages.accounts.deposits.existing_nominee",
                          { defaultValue: "Existing Nominee" }
                        )}
                        bordered={true}
                        onChange={handleNomineeChange}
                        size="large"
                      >
                        {nomineeList.map((option, idx) => (
                          <Select.Option key={idx} value={option.nomineeName}>
                            {option.nomineeName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                {nomineeType === "NEW" && (
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Item
                      label={t("pages.accounts.deposits.new_nominee", {
                        defaultValue: "New Nominee",
                      })}
                      name="nomineeName"
                      rules={[
                        {
                          required: true,
                          message: t(
                            "pages.accounts.deposits.new_nominee_req_txt",
                            { defaultValue: "New Nominee  is required" }
                          ),
                        },
                      ]}
                    >
                      <Input
                        maxLength={19}
                        size="large"
                        onKeyPress={(e) => allowOnlyAlphabetsWithSpace(e)}
                        placeholder={t("pages.accounts.deposits.new_nominee", {
                          defaultValue: "New Nominee",
                        })}
                      />
                    </Form.Item>
                  </div>
                )}

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.relationship", {
                      defaultValue: "Relationship",
                    })}
                    name={"nomineeRelation"}
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.accounts.deposits.relationship_req_txt",
                          { defaultValue: "Relationship is required" }
                        ),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder={t("pages.accounts.deposits.relationship", {
                        defaultValue: "Relationship",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {productList["nomineeRelationShipCodes"].map(
                        (option, idx) => (
                          <Select.Option key={idx} value={option.value}>
                            {option.label}
                          </Select.Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.nominee_date_of_birth", {
                      defaultValue: "Nominee Date of Birth",
                    })}
                    name="nomineeDateOfBirth"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.accounts.deposits.nominee_date_of_birth_req_txt",
                          {
                            defaultValue: "Nominee Date of Birth is required",
                          }
                        ),
                      },
                    ]}
                  >
                    <DatePicker
                      size="large"
                      onChange={(e) => {
                        const ageDiff = moment().diff(e?.$d, "years");
                        setNomineeMinorFlg(ageDiff < 18);
                      }}
                      disabledDate={(current) =>
                        current.isAfter(moment().subtract(0, "days"))
                      }
                      format={"MM/DD/YYYY"}
                      placeholder="MM/DD/YYYY"
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.nominee_address_line1", {
                      defaultValue: "Nominee Address Line1",
                    })}
                    name="nomineeAddress"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.accounts.deposits.nominee_address_line1_req_txt",
                          {
                            defaultValue: "Nominee Address Line1 is required",
                          }
                        ),
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder={t(
                        "pages.accounts.deposits.nominee_address_line1",
                        { defaultValue: "Nominee Address Line1" }
                      )}
                      onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                      maxLength={50}
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.nominee_address_line2", {
                      defaultValue: "Nominee Address Line2",
                    })}
                    name="nomineeAddress1"
                    rules={[
                      {
                        required: false,
                        message: t(
                          "pages.accounts.deposits.nominee_address_line2_req_txt",
                          {
                            defaultValue: "Nominee Address Line2 is required",
                          }
                        ),
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder={t(
                        "pages.accounts.deposits.nominee_address_line2",
                        { defaultValue: "Nominee Address Line2" }
                      )}
                      onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                      maxLength={50}
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.nominee_address_line3", {
                      defaultValue: "Nominee Address Line3",
                    })}
                    name="nomineeAddress2"
                    rules={[
                      {
                        required: false,
                        message: t(
                          "pages.accounts.deposits.nominee_address_line3_req_txt",
                          {
                            defaultValue: "Nominee Address Line3 is required",
                          }
                        ),
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder={t(
                        "pages.accounts.deposits.nominee_address_line3",
                        { defaultValue: "Nominee Address Line3" }
                      )}
                      onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                      maxLength={50}
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.nominee_state", {
                      defaultValue: "Nominee State",
                    })}
                    name={"nomineeState"}
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.accounts.deposits.nominee_state_req_txt",
                          { defaultValue: "Nominee State is required" }
                        ),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder={t("pages.accounts.deposits.nominee_state", {
                        defaultValue: "Nominee State",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {productList["stateCodesList"].map((option, idx) => (
                        <Select.Option key={idx} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.my_accounts.deposits.nominee_city", {
                      defaultValue: "Nominee City",
                    })}
                    name={"nomineeCity"}
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.accounts.deposits.nominee_city_req_txt",
                          { defaultValue: "Nominee City is required" }
                        ),
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder={t(
                        "pages.my_accounts.deposits.nominee_city",
                        {
                          defaultValue: "Nominee City",
                        }
                      )}
                      onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                      maxLength={50}
                    />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder={t("pages.accounts.deposits.nominee_city", {
                        defaultValue: "Nominee City",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {cityList.map((option, idx) => (
                        <Select.Option key={idx} value={option.cityCodeValue}>
                          {option.cityCodeLable}
                        </Select.Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    label={t("pages.accounts.deposits.pincode", {
                      defaultValue: "Pincode",
                    })}
                    name="nomineePostalCode"
                    rules={[
                      {
                        required: true,
                        message: t("pages.accounts.deposits.pincode_req_txt", {
                          defaultValue: "Pincode is required",
                        }),
                      },
                      {
                        min: 5,
                        max: 6,
                        message: t(
                          "pages.accounts.deposits.pincode_valid_txt",
                          { defaultValue: "Please enter valid pincode" }
                        ),
                      },
                    ]}
                  >
                    <Input
                      maxLength={6}
                      size="large"
                      onKeyPress={(e) => allowOnlyNumbers(e)}
                      placeholder={t("pages.accounts.deposits.pincode", {
                        defaultValue: "Pincode",
                      })}
                    />
                  </Form.Item>
                </div>

                {nomineeMinorFlg === true && (
                  <>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t("pages.accounts.deposits.guardian_name", {
                          defaultValue: "Guardian Name",
                        })}
                        name="guardianName"
                        rules={[
                          {
                            required: true,
                            message: t(
                              "pages.accounts.deposits.guardian_name_req_txt",
                              { defaultValue: "Guardian Name  is required" }
                            ),
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          maxLength={CONFIG.BENE_NICKNAME_LENGTH}
                          onKeyPress={(e) => allowOnlyAlphabetsWithSpace(e)}
                          placeholder={t(
                            "pages.accounts.deposits.guardian_name",
                            { defaultValue: "Guardian Name" }
                          )}
                        />
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t("pages.accounts.deposits.relationship", {
                          defaultValue: "Relationship",
                        })}
                        name={"guardianRelation"}
                        rules={[
                          {
                            required: true,
                            message: t(
                              "pages.accounts.deposits.relationship_req_txt",
                              { defaultValue: "Relationship is required" }
                            ),
                          },
                        ]}
                      >
                        <Select
                          size="large"
                          showSearch
                          optionFilterProp="children"
                          placeholder={t(
                            "pages.accounts.deposits.relationship",
                            {
                              defaultValue: "Relationship",
                            }
                          )}
                          bordered={true}
                        >
                          {productList["guardianRelationShipCodes"].map(
                            (option, idx) => (
                              <Select.Option key={idx} value={option.value}>
                                {option.label}
                              </Select.Option>
                            )
                          )}
                        </Select>
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t(
                          "pages.accounts.deposits.guardian_address_line1",
                          { defaultValue: "Guardian Address Line1" }
                        )}
                        name="guardianAddress"
                        rules={[
                          {
                            required: true,
                            message: t(
                              "pages.accounts.deposits.guardian_address_line1_req_txt",
                              {
                                defaultValue:
                                  "Guardian Address Line1 is required",
                              }
                            ),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t(
                            "pages.accounts.deposits.guardian_address_line1",
                            { defaultValue: "Guardian Address Line1" }
                          )}
                          onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                          maxLength={50}
                          size="large"
                        />
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t(
                          "pages.accounts.deposits.guardian_address_line2",
                          { defaultValue: "Guardian Address Line2" }
                        )}
                        name="guardianAddress1"
                        rules={[
                          {
                            required: false,
                            message: t(
                              "pages.accounts.deposits.guardian_address_line2_req_txt",
                              {
                                defaultValue:
                                  "Guardian Address Line2 is required",
                              }
                            ),
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder={t(
                            "pages.accounts.deposits.guardian_address_line2",
                            { defaultValue: "Guardian Address Line2" }
                          )}
                          onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                          maxLength={50}
                        />
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t(
                          "pages.accounts.deposits.guardian_address_line3",
                          { defaultValue: "Guardian Address Line3" }
                        )}
                        name="guardianAddress2"
                        rules={[
                          {
                            required: false,
                            message: t(
                              "pages.accounts.deposits.guardian_address_line3_req_txt",
                              {
                                defaultValue:
                                  "Guardian Address Line3 is required",
                              }
                            ),
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder={t(
                            "pages.accounts.deposits.guardian_address_line3",
                            { defaultValue: "Guardian Address Line3" }
                          )}
                          onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                          maxLength={50}
                        />
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t("pages.accounts.deposits.guardian_state", {
                          defaultValue: "Guardian State",
                        })}
                        name={"guardianState"}
                        rules={[
                          {
                            required: true,
                            message: t("pages.accounts.deposits.", {
                              defaultValue: "Guardian State is required",
                            }),
                          },
                        ]}
                      >
                        <Select
                          size="large"
                          showSearch
                          optionFilterProp="children"
                          placeholder={t(
                            "pages.accounts.deposits.guardian_state",
                            { defaultValue: "Guardian State" }
                          )}
                          bordered={true}
                        >
                          {productList["stateCodesList"].map((option, idx) => (
                            <Select.Option key={idx} value={option.value}>
                              {option.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t("pages.accounts.deposits.guardian_city", {
                          defaultValue: "Guardian City",
                        })}
                        name={"guardianCity"}
                        rules={[
                          {
                            required: true,
                            message: t(
                              "pages.accounts.deposits.guardian_city_req_txt",
                              { defaultValue: "Guardian City is required" }
                            ),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t(
                            "pages.accounts.deposits.guardian_city",
                            { defaultValue: "Guardian City" }
                          )}
                          size="large"
                          onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                        ></Input>
                        {/* <Select
                          size="large"
                          showSearch
                          optionFilterProp="children"
                          placeholder={t(
                            "pages.accounts.deposits.guardian_city",
                            { defaultValue: "Guardian City" }
                          )}
                          bordered={true}
                        >
                          {cityList.map((option, idx) => (
                            <Select.Option
                              key={idx}
                              value={option.cityCodeValue}
                            >
                              {option.cityCodeLable}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                      <Form.Item
                        label={t(
                          "pages.my_accounts.deposits.guardian_pincode",
                          {
                            defaultValue: "Guardian Pincode",
                          }
                        )}
                        name="guardianPostalCode"
                        rules={[
                          {
                            required: true,
                            message: t(
                              "pages.accounts.deposits.guardian_pincode_req_txt",
                              { defaultValue: "Guardian Pincode is required" }
                            ),
                          },
                          {
                            min: 5,
                            max: 6,
                            message: t(
                              "pages.accounts.deposits.pincode_valid_txt",
                              { defaultValue: "Please enter valid pincode" }
                            ),
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          maxLength={6}
                          onKeyPress={(e) => allowOnlyNumbers(e)}
                          placeholder={t("pages.accounts.deposits.pincode", {
                            defaultValue: "Pincode",
                          })}
                        />
                      </Form.Item>
                    </div>
                  </>
                )}

                <p className="mt-3 mb-3">{productList?.alertMsg}</p>

                <p
                  onClick={() =>
                    window.open(depositDetails?.termAndConditionLink, "_blank")
                  }
                  style={{ cursor: "pointer" }}
                  className="mt-3 mb-3 primaryColor"
                >
                  {t("pages.accounts.deposits.terms_and_conditions", {
                    defaultValue:
                      "I have read, I understand & I accept the terms & conditions",
                  })}
                </p>
              </div>
              <div className="d-flex justify-content-end mt-5">
                <Button
                  onClick={() => {
                    setFormType("DEPOSIT_FORM");
                    setNomineeMinorFlg(false);
                    setNomineeType("EXISTING");
                  }}
                  type="default"
                  className="secondary-btn"
                  size="large"
                  style={{ marginRight: 20 }}
                >
                  {t("buttons.back_btn", { defaultValue: "Back" })}
                </Button>
                <Button type="primary" size="large" htmlType="submit">
                  {t("buttons.next_btn", { defaultValue: "Next" })}
                </Button>
              </div>
            </>
          )}
        </Form>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {formValues?.depositType === "FD"
            ? t("pages.accounts.deposits.fixed", {
                defaultValue: "Fixed",
              })
            : t("common.recurring", {
                defaultValue: "Recurring",
              })}{" "}
          {t("pages.accounts.deposits.deposit_review", {
            defaultValue: "deposit review",
          })}
        </h5>
        <p className="mb-4">
          {t("pages.accounts.deposits.verify_txt", {
            defaultValue:
              "Please verify and confirm your request for opening a new ",
          })}
          {formValues?.depositType === "FD"
            ? t("pages.accounts.deposits.fixed", {
                defaultValue: "Fixed",
              })
            : t("common.recurring", {
                defaultValue: "Recurring",
              })}{" "}
          {t("pages.accounts.deposits.deposit", { defaultValue: "deposit" })}
        </p>

        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.accounts.deposits.your_branch", {
                  defaultValue: "Your branch",
                })}
              </label>
              <span>{formValues?.branch}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.accounts.deposits.deposit_type", {
                  defaultValue: "Deposit Type",
                })}
              </label>
              {formValues?.depositType === "FD" && (
                <span>
                  {t("pages.accounts.deposits.fixed_deposit", {
                    defaultValue: "Fixed Deposit",
                  })}
                </span>
              )}
              {formValues?.depositType === "RD" && (
                <span>
                  {t("pages.accounts.deposits.recurring_deposit", {
                    defaultValue: "Recurring Deposit",
                  })}
                </span>
              )}
            </div>

            {formValues?.depositType === "FD" && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.accounts.deposits.interest_payout", {
                    defaultValue: "Interest payout",
                  })}
                </label>
                <span>{formValues?.interestPayout || "-"}</span>
              </div>
            )}

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.accounts.deposits.debit_amount_from", {
                  defaultValue: "Debit amount from",
                })}
              </label>
              <span>{formValues?.accountNo}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.accounts.accounts_common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>{amountFormat(formValues?.amount)}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.accounts.deposits.duration", {
                  defaultValue: "Duration",
                })}
              </label>
              {formValues.depositType === "RD" && (
                <span>
                  {formValues?.months}{" "}
                  {t("pages.accounts.deposits.months", {
                    defaultValue: "Months",
                  })}
                </span>
              )}

              {formValues.depositType === "FD" && (
                <span>
                  {formValues?.years}{" "}
                  {t("pages.accounts.deposits.years", {
                    defaultValue: "Years",
                  })}{" "}
                  {formValues?.months}{" "}
                  {t("pages.accounts.deposits.months", {
                    defaultValue: "Months",
                  })}{" "}
                  {formValues?.days}{" "}
                  {t("pages.accounts.deposits.days", {
                    defaultValue: "Days",
                  })}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-5">
          <Button
            onClick={() => setStage(1)}
            type="default"
            className="secondary-btn"
            size="large"
            style={{ marginRight: 20 }}
          >
            {t("buttons.back_btn", { defaultValue: "Back" })}
          </Button>
          <Button
            loading={loader}
            type="primary"
            size="large"
            onClick={() => openFdOrRdVerify()}
          >
            {t("buttons.confirm", { defaultValue: "Confirm" })}
          </Button>
        </div>
      </>
    );
  }

  function renderSuccess() {
    return (
      <div align="center" className="mt-3">
        <TickIcon height={65} />
        <h6 className="text-align-center mt-5">{respDetails?.message}</h6>
        <p>
          {" "}
          {t("pages.accounts.accounts_common.account_no", {
            defaultValue: "Account Number",
          })}
          : {respDetails?.tdAccountNo}
        </p>

        <p className="mt-3 mb-3">{respDetails?.subMessage}</p>

        <Button
          type="primary"
          size="large"
          className="primary-btn mt-3"
          style={{ width: 150 }}
          onClick={() => navigate("/accounts", { state: "FD" })}
        >
          {t("buttons.done_btn", { defaultValue: "Done" })}
        </Button>
      </div>
    );
  }

  return (
    <>
      
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              {t("navigation.home", { defaultValue: "Home" })}
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts", { state: "FD" })}>
              {t("pages.accounts.accounts_common.accounts", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("pages.accounts.deposits.open_new_deposit", {
                defaultValue: "Open New Deposit",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
     
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.accounts.deposits.open_new_deposit", {
                defaultValue: "Open New Deposit",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card " >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={t("errorMesssages.error", { defaultValue: "Error" })}
        open={visible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.accounts.deposits.minimum_amount_txt", {
            defaultValue: "Minimum amount should be",
          })}{" "}
          {productList?.fdMiniAmount}
        </p>
        <div align="right" className="mt-3">
          <Button
            type="link"
            onClick={() => {
              setVisible(false);
            }}
          >
            {t("buttons.okay_btn", { defaultValue: "Okay" })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={t("errorMesssages.error", { defaultValue: "Error" })}
        open={durationErrorVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        {resident === "NRE" && (
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("pages.accounts.deposits.duration_txt", {
              defaultValue: "Duration should be minimum 12 months.",
            })}
          </p>
        )}

        {resident !== "NRE" && !min7Days && (
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {formValues?.interestPayout}{" "}
            {t("pages.accounts.deposits.fixed_txt", {
              defaultValue:
                "Fixed Deposits can be opened only for 12 & above Months.",
            })}
          </p>
        )}

        {min7Days && (
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("pages.accounts.deposits.duration_txt_7days", {
              defaultValue: "Duration should be minimum 7 days.",
            })}
          </p>
        )}

        <div align="right" className="mt-3">
          <Button
            type="link"
            onClick={() => {
              setDurationErrorVisible(false);
              setMin7Days(false);
            }}
          >
            {t("buttons.okay_btn", { defaultValue: "Okay" })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
